module.exports = __webpack_public_path__ + "img/Infografis_EN_20.248b7fc6.jpg";